import React, { useState } from "react";
import { Accordion, Badge } from "react-bootstrap";
import { ReactComponent as SortIcon } from "assets/images/icons/SortDown.svg";

type FilterConfig = {
  filterType: string;
  label: string;
  key: string;
};

type AccordionFilterProps = {
  nestedFilters: FilterConfig[];
  renderFilterComponent: Function;
  isFilterSelected: Function;
  currentFilters: Record<string, any>;
};

function AccordionFilter(props: AccordionFilterProps) {
  const { nestedFilters, renderFilterComponent, isFilterSelected, currentFilters } = props;

  const [activeAccordion, setActiveAccordion] = useState<string | undefined>(undefined);

  return (
    <>
      {nestedFilters.map((nestedFilter: FilterConfig) => (
        <Accordion
          key={nestedFilter.key}
          onSelect={(eventKey) => setActiveAccordion(eventKey as string)}
          activeKey={activeAccordion}
        >
          <div className="mb-16 ml-3">
            <Accordion.Toggle as="h6" eventKey={nestedFilter.key}>
              <div className="d-flex align-items-center">
                <p className="mb-0 font-weight-bold">{nestedFilter.label}</p>
                <SortIcon
                  className="ml-1"
                  fill="#000"
                  width={8}
                  height={7}
                  transform={`rotate(${activeAccordion === nestedFilter.key ? 180 : 0})`}
                />
                {isFilterSelected(currentFilters[nestedFilter.key]) && (
                  <div className="ml-2">
                    <Badge variant="primary" pill>
                      {Array.isArray(currentFilters[nestedFilter.key]) ? currentFilters[nestedFilter.key]?.length : 1}
                    </Badge>
                  </div>
                )}
              </div>
            </Accordion.Toggle>

            <Accordion.Collapse eventKey={nestedFilter.key}>
              <div className="mt-3">{renderFilterComponent(nestedFilter)}</div>
            </Accordion.Collapse>
          </div>
        </Accordion>
      ))}
    </>
  );
}

export default AccordionFilter;
